import React, { FC, memo } from 'react'

import { styled } from '@linaria/react'
import { animated, SpringValue } from '@react-spring/web'

import { ClipPathInner } from 'components/block/Profile/ProfileMain/profileMain.styled'
import { breakpoints } from 'components/designSystem/shared/breakpoints'
import { zIndex } from 'components/designSystem/zIndex'

export const Trail: FC<{
  bind: Function
  x: SpringValue<number>
  rotate: SpringValue<number>
}> = ({ bind, x, rotate }) => {
  return <Parent {...bind()} style={{ x, rotate }} />
}

export const TrailMemo = memo(Trail)

export const Parent = styled(ClipPathInner)`
  display: block;
  flex-grow: 1;
  position: absolute;
  inset: 1px;
  touch-action: none;
  will-change: transform;
  backface-visibility: hidden;
  transform-origin: bottom;
  cursor: grab;
  user-select: none;
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  transition: background-color 0.3s ease-in;

  @media (min-width: ${breakpoints.mobile + 1}px) {
    z-index: ${zIndex.default};
  }
`

export const WrapperTrails = memo(styled(animated.div)`
  &[data-name='like'] > div:nth-child(1) {
    background-color: var(--pearl-soft);
  }

  &[data-name='like'] > div:nth-child(2) {
    background-color: var(--pearl-default);
  }

  &[data-name='like'] > div:nth-child(3) {
    background-color: var(--pearl-hard);
  }

  &[data-name='dislike'] > div:nth-child(1) {
    background-color: var(--splash-soft);
  }

  &[data-name='dislike'] > div:nth-child(2) {
    background-color: var(--splash-hover);
  }

  &[data-name='dislike'] > div:nth-child(3) {
    background-color: var(--splash-hard);
  }
`)
